import typescriptFsa from 'typescript-fsa';

import { DownloadInvoiceActionData } from './invoice.types';

const actionCreator = typescriptFsa();

export const downloadInvoice = actionCreator.async<DownloadInvoiceActionData, string>('DOWNLOAD_INVOICE');
